/*
	Author : Sohan Kumar Dash
    Project : Pearlgreen
    Date : 17-04-2019
*/

//@module Favorites
define(
	'Favorites.View'
,	[
		'SC.Configuration'

	,	'Favorites.Items.View'
	,	'LiveOrder.Model'
	,	'LiveOrder.Line.Model'
	,	'ProductList.Item.Collection'
	,	'Item.Model'

	,	'favorites.tpl'

	,	'Backbone'
	,	'Backbone.CollectionView'
	,	'Backbone.CompositeView'
	,	'GlobalViews.Pagination.View'
	,	'GlobalViews.ShowingCurrent.View'
	,	'jQuery'
	,	'underscore'
	,	'Utils'
	,	'Tracker'
	]
,	function (
		Configuration

	,	FavoritesItemsView
	,	LiveOrderModel
	,	LiveOrderLineModel
	,	ProductListItemCollection
	,	ItemModel

	,	favorites_tpl

	,	Backbone
	,	BackboneCollectionView
	,	BackboneCompositeView
	,	GlobalViewsPaginationView
	,	GlobalViewsShowingCurrentView
	,	jQuery
	,	_
	,	Utils
	,	Tracker
	)
{
	'use strict';

	//@module Favorites.View @extends Backbone.View
	return Backbone.View.extend({

		template: favorites_tpl

	,	title: _('Favorites').translate()

	,	page_header: _('Favourites').translate()

	,	events:
		{
			'click [data-fav="change-icon"]': 'removeItem'
		,	'change [data-number]': 'changeQuantity'
		,	'change [data-attr="unitstype"]': 'changeUnitsType'
		,	'click	[data-action="add-to-cart"]': 'addToCart'
		,	'click [data-action="search"]': 'searchItemsHandler'
		,	'keypress [name="search-item"]': 'searchItemsHandler'
		,	'click [data-action="clear-input"]': 'clearSearch'
		,	'change [name="sortby"]': 'sortByHandler'
		,	'click [data-action="sort-order"]': 'sortByHandler'
		}
	
	,	filters: [
				{attrName: 'Name',attr: 'storedisplayname2',isActive: false}
			,	{attrName: 'Itemid',attr: 'itemid',isActive: false}
			,	{attrName: 'Price',attr: 'onlinecustomerprice',isActive: false}
		]
	
	,	initialize: function (options)
		{
			this.application = options.application;
			this.isWishListDetail = options.isWishListDetail;
			this.itemCollection = this.model.get('items');
			this.custCollection = new ProductListItemCollection();
			
			this.getUom();
			this.setSelecteds();
			this.getComputedCollection();
		
			this.itemModel = [];
			this.cart = LiveOrderModel.getInstance();

			this.itemCollection.on('add remove reset',function(){
				this.getComputedCollection();
				this.totalRecordsFound = this.model.has('items') ? this.itemCollection.length : void 0;
				this.render();
			},this);

			this.custCollection.on('reset',this.render,this);
			
			BackboneCompositeView.add(this);
		}

	,	childViews:	
		{
			'Favorites.Lists.Items': function()
			{
				return new BackboneCollectionView({
					childView: FavoritesItemsView
				,	collection: this.custCollection || []		//this.model ? this.model.get('items').models : []
				,	viewsPerRow: 1
				});
			}
		,	'GlobalViews.Pagination': function()
			{
				return new GlobalViewsPaginationView(_.extend({
					currentPage: this.page
				,	totalPages: Math.ceil(this.totalRecordsFound / this.recordsPerPage)
				,	pager: this.pager
				}, Configuration.defaultPaginationSettings));
			}

		,	'GlobalViews.ShowCurrentPage': function()
			{
				return new GlobalViewsShowingCurrentView({
					current_page: this.page
				,	items_per_page: this.recordsPerPage
		 		,	total_items: this.totalRecordsFound
				,	total_pages: Math.ceil(this.totalRecordsFound / this.recordsPerPage)
				,	extraClass: 'pull-right'
				});
			}
		}

	,	sortByHandler: function(e)
		{
			var $el = jQuery(e.target)
			,	url = Backbone.history.fragment;
			
			if($el.is('select')) 
			{ 
				this.sortby = $el.val();
				this.setFilters();
			}
			else{
				this.sortorder = $el.data('value');
			}
			url = _.setUrlParameter(url,'sortBy',encodeURI(this.sortby+":"+this.sortorder));
			Backbone.history.navigate(url,{trigger:false});
			this.getComputedCollection();
		}	
		
	,	searchItemsHandler: function(e)
		{
			if(e.keyCode == 13 || event.type == "click")
				this.searchItems();
		}

	,	searchItems: function()
		{
			var searchParam = jQuery('[name="search-item"]').val()
			,	url = Backbone.history.fragment;
			if(!searchParam)
				return;
			this.keyword = searchParam || '';
			url = _.removeUrlParameter(url, 'page');
			url = _.setUrlParameter(url,'item',encodeURI(searchParam));
			this.page = 1;
			Backbone.history.navigate(url,{trigger:false});
			this.getComputedCollection(searchParam);
		}

	,	clearSearch: function(e)
		{
			if(this.keyword)
			{
				jQuery('[name="search-item"]').val('');
				var url = Backbone.history.fragment;
				url = _.removeUrlParameter(url,'item');
				url = _.removeUrlParameter(url,'page');
				this.keyword = '';
				this.page = 1;
				Backbone.history.navigate(url,{trigger:false});
				this.itemCollection.trigger('reset');
			}
		}

	,	removeItem:	function(e)
		{
			e.stopPropagation();

			var	self = this
			,	id =  jQuery(e.target).parent().attr("data-item-id")
			,	itemModel = this.itemCollection.find(function(item){ return item.get('item').get('internalid') == id; });
			
			jQuery('[data-toggle="overlay"]').toggle();
			
			itemModel.destroy().done(function(){
				self.itemCollection.remove(itemModel);
			});
		}
		
	,	setRate: function(product,option,unitId)
		{
			if(product.get('item').get('unitsType') && product.get('item').get('unitsType').length)
			{	
				var unittype = _.find(product.get('item').get('unitsType'), function(unit){ return unit.id == unitId;})
				,	saleUnitObj = _.findWhere(product.get('item').get('unitsType'), {saleUnit: true})
				,	cRate = unittype ? unittype.convertionRate : ""
				,	newprice = ( ( product.getPrice().price/saleUnitObj.convertionRate ) * cRate)
				,	customprice = newprice.toString();

				if(customprice)
				{
					option.set('value', { label: customprice , internalid: customprice });
					product.set('custcol_appf_custom_uom_price_website', customprice );
				}
			}
		}	

	,	pushItem: function(e)
		{
			var	$el = jQuery(e.target)
			,	itemid = jQuery($el).attr("data-item-id")
			,	attr = $el.closest("[data-attr]").data('attr')
			,	$otherEl = jQuery("[data-item-id="+itemid+"]").not($el).closest("[data-attr]")
			,	quantity
			,	options = {};

			options.value = {};

			if( attr == 'quantity' )
			{
				quantity = parseInt( $el.val() );
				options.attr = $otherEl.data('attr');
				options.value.id = $otherEl.val();
				var text = $otherEl.find('option:selected').text().trim()
				options.value.text = text;//.substr(0,text.lastIndexOf(' '));
			}
			if( attr == "unitstype" )
			{
				quantity = parseInt($otherEl.val());
				options.attr = $el.closest("[data-attr]").data('attr');
				options.value.id = $el.closest("[data-attr]").val();
				var text = $el.closest("[data-attr]").find('option:selected').text().trim();
				options.value.text = text;//.substr(0,text.lastIndexOf(' '));
			}
			
			var product = this.itemCollection.find(function(product){ return itemid == product.get('item').get('internalid'); })
			,	line;

			this.addOption(product,options.value);
			product.set('quantity',quantity);
			line = LiveOrderLineModel.createFromProduct(product);
			this.itemModel.push(line);
		}
	
	,	updateItem: function(e)
		{
			var self = this
			,	itemid = jQuery(e.target).attr("data-item-id")
			,	type = jQuery(e.target).data('type')
			,	value = {}
			,	text = jQuery(e.target).find('option:selected').text().trim();

			value.id = jQuery(e.target).val();
			value.text = text;//.substr(0,text.lastIndexOf(' '));

			var lineItem = _.find(this.itemModel,function(line){

				return line.get('item').get('internalid') == itemid ;	
			});

			if(lineItem)
			{
				type && type.search('option') ? this.addOption( lineItem,value ) : lineItem.set('quantity',parseInt( jQuery(e.target).val() ))
			}
			else
				this.pushItem(e);	

		}	

	,	addOption: function(product,value)
		{
			var self = this;
			_.each(product.get('options').models , function(option){

				if(option.get('cartOptionId') == "custcol_appf_custom_uom_website")
				{
					option.set('value',{ internalid:value.id , label:value.id });
					product.set(option.get('cartOptionId'),value.id);
				}
				if(option.get('cartOptionId') == 'custcol_appf_custom_uom_label_website')
				{
					option.set('value', { label: value.text , internalid: value.text });
					product.set('custcol_appf_custom_uom_label_website', value.text );
				}
				if(option.get('cartOptionId') == 'custcol_appf_custom_uom_price_website')
				{
					self.setRate(product,option,value.id);
				}
			});
		}

	,	changeQuantity : function(e)
		{
			e.stopPropagation();
			var	$el = jQuery(e.target),
			itemid = jQuery($el).attr("data-item-id");
			
			var patt = new RegExp("[0-9]");

			if( patt.test( jQuery(e.target).val() ) && parseInt( jQuery(e.target).val() ) != NaN )
			{
				if(this.itemModel.length)
				{
					this.updateItem(e);
				}
				else
				{
					this.pushItem(e);
				}
			}
			else
			{
				var lineItem = _.find(this.itemModel,function(line){
					return line.get('item').get('internalid') == itemid ;	
				});
				var linesToCart = _.reject(this.itemModel, function(num){ return num.id == lineItem.id ;});
				this.itemModel = linesToCart;
				return false;
			}
		}

	,	changeUnitsType: function(e)
		{
			if(this.itemModel.length)
			{
				this.updateItem(e);
			}
			else
			{
				//this.pushItem(e);
				return;
			}	
		}

	,	addToCart: function(e)
		{
			e.stopPropagation();

			if(!this.itemModel.length)
			{
				return;
			}
			if(this.itemModel.length > 0)
			{
				jQuery(e.target).attr("disabled",true)
		
				var cart_promise = this.cart.addLines(this.itemModel);
			
				cart_promise.then(function(){
					jQuery(e.target).attr("disabled",false);
				});
				this.itemModel = [];
				jQuery('[data-number]').each(function(){
					jQuery(this).val('');
				});
			}
			return false;
		}

	

		// @method getContext @return Favorites.View.Context
	,	getContext: function()
		{
			
			return {
				// @class Favorites.View.Context
				isWishListDetailView: this.isWishListDetail

			,	listName: this.model.get("name")

			,	isEmpty: !(this.model.get("items").length ? true : false)

			,	showPagination: this.totalRecordsFound && this.recordsPerPage ? true : false

			,	showCurrentPage: true

			,	itemValue: this.keyword || ''
			
			,	isResultEmpty: (!this.custCollection.length) ? true : false
			
			,	itemCount: this.model.get("items").length
			
			,	filters: this.filters

			,	sortorder: this.sortorder == 'desc' ? true : false
			};
		}

	,	pager: function (url_value)
		{
			var page_number = parseInt(url_value, 10)
			,	url = Backbone.history.fragment;

			return isNaN(page_number) || page_number === 1 ? _.removeUrlParameter(url, 'page') : _.setUrlParameter(url, 'page', page_number);
		}

	,	getPageFromUrl: function (url_value)
		{
			var page_number = parseInt(url_value, 10);

			return !isNaN(page_number) && page_number > 0 ? page_number : 1;
		}
		
	,	setSelecteds: function ()
		{
			this.totalRecordsFound = this.itemCollection.length;
			this.recordsPerPage = 20;

			var url_options = _.parseUrlOptions(Backbone.history.fragment);
			this.page = this.getPageFromUrl(url_options.page);
			this.keyword = url_options.item ? decodeURI(url_options.item) : '';
			
			var sortByParam = url_options.sortBy ? decodeURI(url_options.sortBy) : '' 
			this.sortby = sortByParam ? sortByParam.substr(0,sortByParam.lastIndexOf(':')): '';
			this.sortorder = sortByParam ? sortByParam.slice(sortByParam.lastIndexOf(':')+1,sortByParam.length) : 'asc';
			this.setFilters();
		}
		
	,	setFilters: function()
		{
			_.each(this.filters || [] ,function(filter){
				if(filter.attr == this.sortby)
				{
					filter.isActive = true;
				}
				else
					filter.isActive = false;
			},this);
		}	

	,	getComputedCollection: function(param)
		{
			var totalPages = Math.ceil(this.totalRecordsFound / this.recordsPerPage)
			,	start_index = this.recordsPerPage * ( (this.page > totalPages ? 1 : this.page) - 1)
			,	end_index = this.recordsPerPage * (this.page > totalPages ? 1 : this.page)
			,	self= this;

			this.page > totalPages ? Backbone.history.navigate(_.removeUrlParameter(Backbone.history.fragment,'page'),{trigger:false}) : (void 0);		
			this.page = 1;
			this.sortByParam(this.itemCollection.models);
			if(param || this.keyword)
			{
				var filtered = this.itemCollection.filter(function(model){
					return ((model.get('item').get('displayname').search(new RegExp( (param || self.keyword) , "ig")) !== -1) || (model.get('item').get('itemid').search(new RegExp( (param || self.keyword) , "ig")) !== -1));
				});
				
				this.totalRecordsFound = filtered.length;
				this.custCollection.reset(filtered.slice(start_index,end_index));
			}
			else
			{
				this.custCollection.reset(this.itemCollection.slice(start_index,end_index));
			}
		}
		
	,	sortByParam: function(models)
		{
			if(models && models.length>1)
			{
				this.sortby = this.sortby || 'itemid'
				var items_smpl = _.map(models, function(model){ return model.has('item') ? model.get('item').toJSON() : (void 0); })
				,	sorted_items = this.getSortedItem(items_smpl,this.sortby)
				,	option = {silent:true} 
				,	sorted_models = [];
				_.each(this.sortorder == 'desc' ? sorted_items.reverse() : sorted_items, function(item){
					var model_f = _.find(models, function(model){ return item.internalid == model.get('item').get('internalid'); });
					model_f ? sorted_models.push(model_f.set('item',new ItemModel(item))) : (void 0);
				});
				this.itemCollection.reset(sorted_models,option);
			}
		}

	,	getSortedItem: function(items_smpl,param)
		{
			return _.sortBy(items_smpl,function(item){
				var iteratee = '';
				switch (param) {
					case 'onlinecustomerprice':
						iteratee = item.onlinecustomerprice_detail.onlinecustomerprice;
						break;
				
					default:
						iteratee = item[param];
						break;
				}
				return iteratee;
			});
		}	

	,	getUom: function()
		{
			var self = this
			,	itemid = _.map(this.itemCollection.models,function(itemModel){
								return itemModel.get('item').get('internalid');
							})			
			,	itemid_cp = [];
			
			itemid.forEach(function(id){
				(id && id != 'undefined' && id != 'null') ? itemid_cp.push(id) : (void 0)
			});
			itemid = itemid_cp;

			var itemid_stringify = JSON.stringify(itemid);
			var itemid_to_be_passed = itemid_stringify.slice(1,-1);

			Backbone.ajax({
				url: Utils.getAbsoluteUrl('services/GetUOM.Service.ss'),
				data: {itemid:itemid_to_be_passed},
				success: function(val){
					
					self.model.get('items').models.forEach(function(itemModel){
						
						var unitsObj = _.find(val , function(id){
							if(id.uomExists == true)
							return id.internalid == itemModel.get('item').get('internalid');
						});
						itemModel.get('item').set('unitsType', unitsObj ? unitsObj.unitstype : []);
					});
					self._render();
				}
			});
		}

	});
});

